module.exports = __webpack_public_path__ + "img/checkin-1.32655194.png";